module.exports = __webpack_public_path__ + "Cooking-pana-9e7578ff2c1fc12638518669fe5e1276.png";